/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_Product_BrandInputs */

const en_gallery_category_product_brand = /** @type {(inputs: Gallery_Category_Product_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product & Brand`)
};

const es_gallery_category_product_brand = /** @type {(inputs: Gallery_Category_Product_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto y marca`)
};

/**
* | output |
* | --- |
* | "Product & Brand" |
*
* @param {Gallery_Category_Product_BrandInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_product_brand = /** @type {((inputs?: Gallery_Category_Product_BrandInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_Product_BrandInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_product_brand(inputs)
	return es_gallery_category_product_brand(inputs)
});